module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "sec-7"
    }
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "pz7-1"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "pz7-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/frontmatter02#pz9-1",
      "id": "x1"
    }
  }, [_c('b', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "Asf"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#pz11-8",
      "id": "x2"
    }
  }, [_c('b', [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "AFp"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#pz11-7",
      "id": "x3"
    }
  }, [_vm._v("An Invitation to Discipleship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "Aux"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#pz25-6",
      "id": "x4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "AJW"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#pz25-7",
      "id": "x5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Starting with God: The Trinity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "AhG"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#pz47-6",
      "id": "x6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "AiA"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#pz47-8",
      "id": "x7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Participating in God’s Story: Eschatology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "A4tG"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#pz69-8",
      "id": "x8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Four")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "A6Ig"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#pz69-7",
      "id": "x9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Encountering the Living Word: Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "A26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#pz91-7",
      "id": "x10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Five")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "AWay"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#pz91-8",
      "id": "x11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pursuing Intentional Discipleship: The Believers Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "AVSG"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#pAB63",
      "id": "x12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Six")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "ABE"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#pz115-7",
      "id": "x13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Experiencing God in Community: The Sacraments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "A7S"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#pz137-8",
      "id": "x14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Seven")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "AO90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#pz137-7",
      "id": "x15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Participating in God’s Purposes: Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "AQW"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#pz159-8",
      "id": "x16",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter Eight")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "AZd"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#pz159-7",
      "id": "x17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological Commitments in Churches of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "AqL_"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter01#pz165-1",
      "id": "x18",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Response")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "Ae1g"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter01#pz165-2",
      "id": "x19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("by Lauren Smelser White")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "AGT"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter02#pz172-1",
      "id": "x20",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Response")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "AKll"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter02#pz172-2",
      "id": "x21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("by Stanley Talbert")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "Ay-"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter03#pz177-1",
      "id": "x22",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Response")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "AY2X"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter03#pz177-2",
      "id": "x23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("by Carson E. Reed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "Aqv6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter04#pz185-6",
      "id": "x24",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Appendix One:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "Auv"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter04#pz185-7",
      "id": "x25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rules of Faith and Ecumenical Creeds of the Early Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "A6Q-"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter05#pz189-1",
      "id": "x26",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Appendix Two:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "AWX"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/backmatter05#pz189-2",
      "id": "x27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alexander Campbell’s “Summary View of the Christian System of Facts”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f6ec521","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contenttoc.vue
// module id = 69
// module chunks = 0